__turbopack_context__.v({
  "component": "Bwr7Xq_component",
  "component__NFLSTLegal": "Bwr7Xq_component__NFLSTLegal",
  "component__content": "Bwr7Xq_component__content",
  "component__contentWrapper": "Bwr7Xq_component__contentWrapper",
  "component__formLead": "Bwr7Xq_component__formLead",
  "component__formWrapper": "Bwr7Xq_component__formWrapper",
  "component__headline": "Bwr7Xq_component__headline",
  "component__headlineWrapper": "Bwr7Xq_component__headlineWrapper",
  "component__horizonHeadline": "Bwr7Xq_component__horizonHeadline",
  "component__icon": "Bwr7Xq_component__icon",
  "component__mobileBackground": "Bwr7Xq_component__mobileBackground",
  "component__pricingWrapper": "Bwr7Xq_component__pricingWrapper",
  "component__selectAreasLegal": "Bwr7Xq_component__selectAreasLegal",
  "component__subHeadline": "Bwr7Xq_component__subHeadline",
  "component__wrapper": "Bwr7Xq_component__wrapper",
  "hide-for-large": "Bwr7Xq_hide-for-large",
  "hide-for-large-only": "Bwr7Xq_hide-for-large-only",
  "hide-for-medium": "Bwr7Xq_hide-for-medium",
  "hide-for-medium-only": "Bwr7Xq_hide-for-medium-only",
  "hide-for-small-only": "Bwr7Xq_hide-for-small-only",
  "show-for-large": "Bwr7Xq_show-for-large",
  "show-for-large-only": "Bwr7Xq_show-for-large-only",
  "show-for-medium": "Bwr7Xq_show-for-medium",
  "show-for-medium-only": "Bwr7Xq_show-for-medium-only",
  "show-for-small-only": "Bwr7Xq_show-for-small-only",
  "u-color-black": "Bwr7Xq_u-color-black",
  "u-color-blue": "Bwr7Xq_u-color-blue",
  "u-color-midnight": "Bwr7Xq_u-color-midnight",
  "u-color-primary-dark": "Bwr7Xq_u-color-primary-dark",
  "u-color-red": "Bwr7Xq_u-color-red",
  "u-color-white": "Bwr7Xq_u-color-white",
  "u-theme-black": "Bwr7Xq_u-theme-black",
  "u-theme-blue": "Bwr7Xq_u-theme-blue",
  "u-theme-dark": "Bwr7Xq_u-theme-dark",
  "u-theme-light": "Bwr7Xq_u-theme-light",
  "u-theme-red": "Bwr7Xq_u-theme-red",
  "u-theme-white": "Bwr7Xq_u-theme-white",
});
